var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1000.000000pt",
    height: "1000.000000pt",
    viewBox: "0 0 1000.000000 1000.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1000.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3970 9834 c-551 -32 -1074 -171 -1555 -414 -638 -322 -1179 -817 -1556 -1423 -613 -985 -753 -2187 -384 -3292 146 -438 357 -824 664 -1210 126 -159 423 -455 591 -589 497 -397 1055 -657 1675 -781 240 -48 405 -66 675 -72 462 -11 879 50 1305 192 427 141 767 319 1132 592 61 45 115 83 120 83 4 0 613 -605 1353 -1345 l1345 -1345 140 140 140 140 -1342 1343 -1341 1342 101 110 c557 608 893 1331 1004 2165 23 169 26 733 5 900 -111 899 -480 1675 -1095 2299 -643 652 -1466 1052 -2364 1146 -147 16 -489 26 -613 19z m595 -419 c1535 -178 2775 -1341 3045 -2855 48 -269 65 -666 40 -935 -62 -673 -309 -1292 -736 -1845 -110 -143 -412 -448 -559 -564 -512 -407 -1106 -658 -1756 -741 -174 -23 -521 -30 -704 -16 -1064 86 -2017 640 -2618 1522 -501 736 -698 1616 -561 2505 170 1103 871 2066 1874 2574 443 224 846 332 1395 374 98 8 452 -4 580 -19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e0b78fb3443560cc4e3ea071f1e0ee20.svg";
export { ForwardRef as ReactComponent };